import React from "react";
import "./DiscoverArchiveSection.scss";
import VerticalBar from "../VerticalBar/VerticalBar";

const DiscoverArchiveSection = ({
  image,
  title = "ARCHIVE PROJECT",
  linkText = "Archive",
  linkUrl = "/archive-access",
  subtitle = "coming soon",
  footer = "X X X",
}) => {
  return (
    <section className="archive-section">
      <div
        className="archive-section__image"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.65)), url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="left-archive-section">
        <div className="div-left-archive-section">
          <div className="archive-section__content">
            <div className="archive-section_content2">
              <a
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="archive-section__button"
              >
                {linkText} <span>↗</span>
              </a>
              <p className="archive-section__subtitle">{subtitle}</p>
              <div className="dots-pattern arc-pattern"></div>
            </div>
            <div className="archive-title2">
              <h2 className="archive-section__title">{title}</h2>
            </div>
          </div>

          <div className="hh">
            <div className="archive-footer">{footer}</div>
            <div className="dots-pattern"></div>
          </div>
        </div>
      </div>
      <div className="right-archive-section">
        <div className="hh2">
          <VerticalBar />
          <div className="dots-pattern dots-pattern3"></div>
        </div>{" "}
      </div>
    </section>
  );
};

export default DiscoverArchiveSection;
